import { TriangleDay } from "../../models/triangle-day";
import { useContext, useEffect, useRef, useState } from "react";

export function TriangleChart(props: { days: TriangleDay[] | null[] }) {
  const [triangles, setTriangles] = useState<any[]>([]);
  const [selectedTriangle, setSelectedTriangle] = useState<any>(null);

  useEffect(() => {
    const arr: any[] = [];
    props.days.map((day, index) => {
      if (day) {
        const date = new Date(day.date);
        let triangleColor;
        if (day.locationsWithQualityAlerts > 0) {
          triangleColor = "#ff443a";
        } else if (day.locationsWithNearMiss > 0) {
          triangleColor = "#fedd00";
        } else {
          triangleColor = "#34c759";
        }
        if (new Date() < date) {
          triangleColor = "#e2e2e2";
        }
        const row = getRow(date.getUTCDate());
        let rotate = 0;
        if (row <= 3) {
          if (((row % 2) + date.getUTCDate()) % 2 == 1) {
            rotate = 180;
          }
        } else {
          if (((row % 2) + date.getUTCDate()) % 2 == 0) {
            rotate = 180;
          }
        }

        const col = getCol(date.getUTCDate());

        arr.push({
          triangleColor: triangleColor,
          left: 17.5 * (row - 1) + 17.5 * (col - 1),
          bottom: 17.5 + 30.45 * (row - 1),
          rotation: rotate,
          day: date.getUTCDate(),
          date: date.toUTCString(),
          locationsWithNoIssues: day.locationsWithNoIssues,
          locationsWithNearMiss: day.locationsWithNearMiss,
          locationsWithQualityAlerts: day.locationsWithQualityAlerts,
          totalQualityAlerts: day.totalQualityAlerts,
          totalNearMisses: day.totalNearMisses,
        });
      }
    });
    setTriangles(arr);
  }, [props.days]);

  function getRow(day: number) {
    if (day >= 1 && day <= 11) {
      return 1;
    } else if (day >= 12 && day <= 20) {
      return 2;
    } else if (day >= 21 && day <= 27) {
      return 3;
    } else if (day >= 28 && day <= 30) {
      return 5;
    } else if (day == 31) {
      return 6;
    } else {
      return 0;
    }
  }

  function onHover(triangle: any) {
    setSelectedTriangle(triangle);
  }

  function offHover(triangle: any) {
    if (triangle == selectedTriangle) {
      setSelectedTriangle(null);
    }
  }

  function getCol(day: number) {
    const row = getRow(day);
    switch (row) {
      case 1:
        return day;
      case 2:
        return day - 11;
      case 3:
        return day - 20;
      case 5:
        return day - 27;
      case 6:
        return 1;
      default:
        return 0;
    }
  }

  while (triangles.length >= 28 && triangles.length < 30) {
    let monthLastDay = triangles[triangles.length - 1];
    let dayObj = JSON.parse(JSON.stringify(monthLastDay));

    dayObj.day = triangles.length + 1;
    dayObj.triangleColor = "#e2e2e2";
    dayObj.left = monthLastDay.left + 17.5;
    dayObj.date = "";

    dayObj.rotation = (triangles.length + 1) % 2 === 1 ? 180 : 0;

    triangles.push(dayObj);
  }

  return (
    <div className="relative h-[210px] w-[210px] overflow-visible">
      {triangles.map((triangle, index) => {
        return (
          <div
            key={triangle.day}
            className={`triangle absolute flex h-[30.45px] w-[35px] items-end justify-center`}
            style={{
              left: `${triangle.left}px`,
              bottom: `${triangle.bottom}px`,
              transform: `rotate(${triangle.rotation}deg)`,
              background: `${triangle.triangleColor}`,
            }}
            onMouseEnter={() => onHover(triangle)}
            onMouseLeave={() => offHover(triangle)}
          >
            <span
              className={`${triangle.rotation == 180 ? "rotate-180" : ""} text-[9px]`}
            >
              {triangle.day}
            </span>
          </div>
        );
      })}
      {triangles.length != 31 && triangles.length > 0 && (
        <div
          key={31}
          className={`triangle absolute flex h-[30.45px] w-[35px] items-end justify-center`}
          style={{
            left: `87.5px`,
            bottom: `170.25px`,
            transform: `rotate(0deg)`,
            background: `#e2e2e2`,
          }}
        >
          <span className={`text-[9px]`}>31</span>
        </div>
      )}
      {triangles.length > 0 && (
        <img
          src="/dashboard/qnet-login-screen-logo-1.png"
          className="absolute bottom-[110.25px] left-[68.25px] h-[27px]"
        />
      )}
      {selectedTriangle && (
        <div
          className="absolute z-[99999999] w-[140px] rounded border-[1px] border-[#E5E5E5] bg-[#ffffff] p-[17.5px]"
          style={{
            left: `${selectedTriangle.left + 35}px`,
            bottom: `${selectedTriangle.bottom - 245}px`,
          }}
        >
          <div className="mb-[21px]">
            <h1 className="text-[17px] font-bold">Daily Snapshot</h1>
            <h6 className="text-[9.8px] font-semibold text-[#64748b]">
              {selectedTriangle.date}
            </h6>
          </div>
          <div className="mb-[7px] border-l-[2.1px] border-tqsGreen pl-[4.9px]">
            <h6 className="text-[9.8px] font-semibold text-[#64748b]">
              No issues <br /> Reported
            </h6>
            <h4 className="font-bold">
              {selectedTriangle.locationsWithNoIssues} Locations
            </h4>
          </div>
          <div className="mb-[7px] border-l-[2.1px] border-[#fedd00] pl-[4.9px]">
            <h6 className="text-[9.8px] font-semibold text-[#64748b]">
              Near Misses <br /> Reported
            </h6>
            <h4 className="font-bold">
              {selectedTriangle.locationsWithNearMiss} Locations
            </h4>
            <h5 className="rounded border border-yellow-300 bg-yellow-100 text-center text-[8.1px] text-yellow-500">
              {selectedTriangle.totalNearMisses} near misses
            </h5>
          </div>
          <div className="mb-[7px] border-l-[2.1px] border-[#ff443a] pl-[4.9px]">
            <h6 className="text-[9.8px] font-semibold text-[#64748b]">
              Quality Alerts <br /> Reported
            </h6>
            <h4 className="font-bold">
              {selectedTriangle.locationsWithQualityAlerts} Locations
            </h4>
            <h5 className="rounded border border-red-300 bg-red-100 text-center text-[8.1px] text-red-500">
              {selectedTriangle.totalQualityAlerts} quality alerts
            </h5>
          </div>
        </div>
      )}
    </div>
  );
}
